import { render, staticRenderFns } from "./BloodSugarShowCreateEdit.vue?vue&type=template&id=48036282&scoped=true&"
import script from "./BloodSugarShowCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BloodSugarShowCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48036282",
  null
  
)

export default component.exports